import styled from "styled-components";

export const TDIcon = styled.div`
  color: red;
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    opacity: 0.75;
  }
  svg {
    float: left;
    width: 38px;
  }
`;

export const TH_Container = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  ${(props) => props.isSorted && `background-color: #efefef`}
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;

  .input-page {
    margin: 0 2rem;
  }

  select {
    margin-left: 1rem;
  }
`;

export const PageNavButton = styled.button`
  background-color: #f7fafd;
  border: 1px solid white;
  border-radius: 5px;
  color: #7fa1c8;
  height: 34px;
  width: 34px;
  padding: 0;

  &:hover:enabled {
    color: #7fa1c8;
    background-color: #e4f0fb;
  }

  &:disabled {
    background-color: #f7f7f7;
    cursor: not-allowed;
    color: lightgray;
  }
`;

export const PageInput = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
  width: 60px;
  text-align: center;
`;
export const ModalHeader = styled.div`
  background-color: rgb(247, 247, 247);
  border: 1px solid rgb(226, 226, 226);
  padding: 0.4rem 1rem;
  line-height: 1.6;
  margin-top: 0px;
`;
export const ModalBody = styled.div`
  padding: 1rem;
`;
export const ModalActionToolbar = styled.div`
  display: flex;
  padding: 1rem;
  button {
    margin-left: auto;
  }
`;
